// Convert [-1; 1] coordinates into [0; 100] and invert y value
var convertPoiToPercent = function (xToConvert, yToConvert) {
    return {
        x: (((xToConvert + 1) * 10000) / 2 / 10000) * 100,
        y: (((1 - yToConvert) * 10000) / 2 / 10000) * 100
    };
};
// Convert [0; 100] coordinates into [-1; 1] and invert y value
var convertPoiToDecimal = function (xToConvert, yToConvert) {
    return {
        x: xToConvert / 50 - 1,
        y: (yToConvert / 50 - 1) * -1
    };
};
// Return true if the parameter is not a float between 0 and 100
var isWrongCoordonate = function (value) {
    if (!value || value.trim() === "") {
        return true;
    }
    var valid = !isNaN(+value) && isFinite(+value) && !/e/i.test(value);
    if (valid) {
        var float = parseFloat(value);
        return float > 100 || float < 0;
    }
    return true;
};

export { convertPoiToDecimal, convertPoiToPercent, isWrongCoordonate };
//# sourceMappingURL=utils.js.map
